module.exports = __webpack_public_path__ + "static/media/address-card.a126ca33.svg";